import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalInstance } from './b2cConfiguration';
import { Provider } from 'react-redux';
import { store } from './store/store';

const b2cConfig = msalInstance;

const pca = new PublicClientApplication(b2cConfig);

const AppProvider = () => (
    <MsalProvider instance={pca}>
        <Provider store={store}>
            <App />
        </Provider>
    </MsalProvider>
);

ReactDOM.render(<AppProvider />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
